import actions from './actions';

const initState = {
    access: null,
    refresh: null,
    accessTokenExpiration: null,
    refreshTokenExpiration: null,
    user: null,
    image: null,
    permission: [],
    Email: [],
    role: null,
    is_superuser: false,
    company: [],
    first_name: null,
    last_name: null,
    middle_name: null,
    IPAddress: [],
    selected_userpermissions: [],
    sessionResetting: false,
    sessionEpoch: 0
};
export default function authReducer(state = initState, action) {
    switch (action.type) {
        case actions.SESSION_RESET_REQUEST:
            return {
                ...state,
                sessionResetting: true,
            };
        case actions.SESSION_RESET:
        case actions.SESSION_RESET_REMOTE:
            return {
                ...initState,
                sessionResetting: true,
                sessionEpoch: (state.sessionEpoch || 0) + 1,
            };
        case actions.SESSION_RESET_SUCCESS:
            return {
                ...state,
                sessionResetting: false,
            };
        case actions.LOGIN_SUCCESS:

            return {
                ...state,
                sessionResetting: false,
                sessionEpoch: (state.sessionEpoch || 0) + 1,
                access: action.access,
                refresh: action.refresh,
                accessTokenExpiration: action.accessTokenExpiration,
                refreshTokenExpiration: action.refreshTokenExpiration,
                user: action.user,
                userId: action.userId,
                image: action.image,
                company: action.company,
                user_facilities: action.user_facilities,
                is_companyadmin: action.is_companyadmin,
                is_superuser: Boolean(action.is_superuser),
                permission: action.permission,
                role: action.role,
                first_name: action.first_name,
                last_name: action.last_name,
                middle_name: action.middle_name,
                email: action.email,
            };
        case actions.UPDATE_TOKEN:
            return {
                ...state,
                access: action.payload.access,
                refresh: action.payload.refresh,
                accessTokenExpiration: action.payload.accessTokenExpiration,
                refreshTokenExpiration: action.payload.refreshTokenExpiration,
            }
        case actions.USERINFO_UPDATE_SUCCESS:
            return {
                ...state,
                user: action.user,
                userId: action.userId,
                image: action.image,
                company: action.company,
                user_facilities: action.user_facilities,
                is_companyadmin: action.is_companyadmin,
                is_superuser: Boolean(action.is_superuser),
                permission: action.permission,
                role: action.role,
                first_name: action.first_name,
                last_name: action.last_name,
                middle_name: action.middle_name,
                email: action.email,
            };
        case actions.USER_UPDATE:
            return {
                ...state,
                ...action.payload
            };
        case actions.IPADDRESS:
            return {
                ...state,
                IPAddress: action.payload.data
            }

        case actions.SELECT_USERPERMISSIONS:
            return {
                ...state,
                selected_userpermissions: action.payload.data
            }

        default:
            return state;
    }
}
